type FleeterIconProps = {
	className?: string;
	size?: number;
};

export const FleeterIcon = ({
	className = "",
	size = 20,
}: FleeterIconProps) => (
	<svg
		className={className}
		fill="none"
		height={size * 1.2}
		viewBox="0 0 16 24"
		width={size}
		xmlns="http://www.w3.org/2000/svg"
	>
		<title>Fleeter</title>
		<path
			d="M15.8024 -3.05176e-05L14.5966 5.03324L14.4828 5.51465C12.9707 5.57336 11.439 5.85124 9.93093 6.36788C9.02371 6.67707 8.16362 7.06455 7.35851 7.51465C5.1474 8.74361 3.31724 10.4618 1.9623 12.4775C1.1297 13.7143 0.473829 15.0645 0.0182537 16.4853C-0.0485116 15.1272 0.0693095 13.7808 0.348153 12.4775C0.72518 10.7162 1.40069 9.04107 2.33933 7.51465C2.88523 6.63011 3.51754 5.79645 4.22839 5.03324C5.94073 3.19762 8.11256 1.74165 10.6536 0.868854C12.362 0.28177 14.0939 -3.05176e-05 15.8024 -3.05176e-05Z"
			fill="currentColor"
		/>
		<path
			d="M15.8024 7.51465L14.5967 12.5479L14.4828 13.0293C12.9708 13.088 11.4391 13.3659 9.93099 13.8826C9.02376 14.1918 8.16367 14.5792 7.35856 15.0293C5.14745 16.2583 3.3173 17.9765 1.96235 19.9921C1.12975 21.2289 0.473882 22.5792 0.0183071 24C-0.0484582 22.6418 0.0693629 21.2955 0.348206 19.9921C0.725234 18.2309 1.40074 16.5557 2.33938 15.0293C2.88529 14.1448 3.51759 13.3111 4.22845 12.5479C5.94078 10.7123 8.11261 9.25633 10.6536 8.38353C12.3581 7.80036 14.0901 7.51856 15.7945 7.51856L15.8024 7.51465Z"
			fill="currentColor"
		/>
	</svg>
);
